import lodash from 'lodash';
import { OrderingSelectors } from 'polygon-ordering';
import React, { useEffect, useRef } from 'react';

import { Row } from 'reactstrap';
import { TEXT_PROPERTIES } from '../utils/theme';
import { useAppSelector } from '../app/hooks';
import combineStyles from '../utils/combineStyles';
import MenuItem from './MenuItem';
import Text from './Text';
import getThemeLookup from '../selectors/getThemeLookup';
import DayPartChip from './DayPartChip';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';

const { getDayPartMenuConfig, getCategoryAvailabilityById } = OrderingSelectors;
interface IProps {
  category: Category;
  reportRef?: (id: string, ref: React.RefObject<HTMLDivElement>) => void;
  shrinkMargin?: boolean;
}
const MenuCategory: React.FC<IProps> = props => {
  const ref = useRef<HTMLDivElement>(null);
  const { category, reportRef, shrinkMargin = false } = props;
  const disableCategoryCount = useAppSelector(state => state.config.disableCategoryCount);
  const p = useAppSelector(getThemeLookup);
  const isDeviceMobile = useAppSelector(getDeviceTypeMobile);

  useEffect(() => {
    if (reportRef) {
      reportRef(category.id, ref);
    }
  }, []);

  const dayPartMenuConfig = useAppSelector(getDayPartMenuConfig);
  const { hideUnavailableCategories } = dayPartMenuConfig;

  const [dayPartAvailability, dayPartString] = useAppSelector(
    getCategoryAvailabilityById(category.id),
  );

  return !(!dayPartAvailability && hideUnavailableCategories) ? (
    <section ref={ref} style={shrinkMargin ? {} : combineStyles(styles.category)}>
      <div style={combineStyles(styles.categoryName, isDeviceMobile && styles.categoryNameMobile)}>
        <Text
          themeKey="menuListItemHeading"
          variant="h1"
          style={combineStyles(p('menuCategoryHeading', TEXT_PROPERTIES), styles.heading)}
        >
          {`${category.name} `}
          {!disableCategoryCount ? (
            <Text themeKey="menuCategoryHeadingCount">{`(${category.items.length})`}</Text>
          ) : null}
        </Text>
        <DayPartChip value={dayPartString} />
      </div>

      <div>
        <Row>
          {lodash.map(category?.items, item => (
            <MenuItem key={item.id} item={item} brandId={category.brandId} category={category} />
          ))}
        </Row>
      </div>
    </section>
  ) : null;
};
const styles: Styles = {
  availability: {
    fontSize: 12,
    opacity: 0.6,
  },
  categoryName: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1em',
    rowGap: 4,
    columnGap: 10,
    flexWrap: 'wrap',
  },
  category: {
    marginBottom: '2em',
  },
  heading: {
    display: 'inline-block', // should this be on all Text components?
  },
};

export default MenuCategory;
